<form [formGroup]="form" class="container">
  <app-titulo>Autorização de Engate</app-titulo>
  <app-input
    type="email"
    label="E-mail ou Username"
    name="TX_MAIL_FUNC"
    formControlName="TX_MAIL_FUNC"
    placeholder="Digite aqui"></app-input>
  <app-input
    type="password"
    label="Senha"
    name="TX_SENH_FUNC"
    formControlName="TX_SENH_FUNC"
    placeholder="Digite aqui"></app-input>
  <div class="buttons">
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()" buttonType="button" />
    <app-botao
      text="Acessar"
      [bgColor]="!form.valid ? '' : '#059669'"
      (click)="postLogin()"
      [disabled]="!form.valid" />
  </div>
</form>

<app-loader *ngIf="isLoading" />
